import CCIcon from "../assets/images/clients.svg?svgr";
import ClientsList from "../assets/images/clients-list.svg?svgr";
import LeadImg from "../assets/images/lead.svg?svgr";
import ClientsActive from "../assets/images/clients-active.svg?svgr";
import BonusIcon from "../assets/images/bonus_icon.svg?svgr";
import Accounts from "../assets/images/accounts.svg?svgr";
import Providers from "../assets/images/Providers.svg?svgr";
import Fb from "../assets/images/services/fb-sidebar.svg?svgr";
import TT from "../assets/images/services/icon-tt-sidebar.svg?svgr";
import ResetPayline from "../assets/images/resetPayline.svg?svgr";
import Payline from "../assets/images/payline.svg?svgr";
import Google from "../assets/images/services/google-sidebar.svg?svgr";
import ManualManagement from "../assets/images/manualManagement.svg?svgr";
import Commission from "../assets/images/commission.svg?svgr";
import FinDocIcon from "../assets/images/finDoc.svg?svgr";
import Client from "../assets/images/client.svg?svgr";
import Reporting from "../assets/images/Reporting.svg?svgr";
import Sentinel from "../assets/images/sentinel.svg?svgr";
import { TbReportMoney } from "react-icons/tb";
import { RiRefund2Line } from "react-icons/ri";
import { MdMoneyOff } from "react-icons/md";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { HiOutlineDocumentCurrencyDollar } from "react-icons/hi2";
import { TbLockAccess } from "react-icons/tb";
import { MdCurrencyExchange } from "react-icons/md";
import { TbTax } from "react-icons/tb";
import { MdOutlineFactCheck } from "react-icons/md";
import { FaRegHandshake } from "react-icons/fa";
import { GrTransaction } from "react-icons/gr";
import { LiaHandsHelpingSolid } from "react-icons/lia";
import { FaHammer } from "react-icons/fa";


export const sidebarItemTypes = Object.freeze({
  clients:"clients",
  clientList:"clientList",
  leadList:"leadList",
  clientsActivity:"clientsActivity",
  partnerProgram:"partnerProgram",
  partnerProgramTerms:"partnerProgramTerms",
  partnerProgramRequests:"partnerProgramRequests",
  bonusProgram:"bonusProgram",
  bonusProgramTerms:"bonusProgramTerms",
  bonusProgramReport:"bonusProgramReport",
  adAccount:"adAccount",
  providers:"providers",
  facebookReg:"facebookReg",
  tikTokReg:"tikTokReg",
  PLVerification:"PLVerification",
  PLPostVerification:"PLPostVerification",
  verifyPayLine:"verifyPayLine",
  verifySalesPayLine:"verifySalesPayLine",
  googleMcc:"googleMcc",
  manualTransactions:"manualTransactions",
  manualPayment:"manualPayment",
  manualDebiting:"manualDebiting",
  operationClosing:"operationClosing",
  manualPenalty:"manualPenalty",
  commissions:"commissions",
  finDocs:"finDocs",
  paymentProblems:"paymentProblems",
  competitionCertificate:"competitionCertificate",
  usersItem:"usersItem",
  users:"users",
  projectsAccesses:"projectsAccesses",
  reportsItem:"reportsItem",
  reports:"reports",
  exchangeRate:"exchangeRate",
  googleTax:"googleTax",
  preModeration:"preModeration",
  advPartners:"advPartners",
  demoCabinet: "demoCabinet",
  sentinel:"sentinel"
});

export const sidebarIcon = Object.freeze({
  [sidebarItemTypes.clients]: <CCIcon height={20} width={20}/>,
  [sidebarItemTypes.clientList]: <ClientsList height={20} width={20} />,
  [sidebarItemTypes.leadList]: <LeadImg height={20} width={20} />,
  [sidebarItemTypes.clientsActivity]: <ClientsActive height={20} width={20} />,
  [sidebarItemTypes.partnerProgram]: <FaRegHandshake size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.partnerProgramTerms]: <ClientsList height={20} width={20} />,
  [sidebarItemTypes.partnerProgramRequests]: <ClientsActive height={20} width={20} />,
  [sidebarItemTypes.bonusProgram]: <BonusIcon height={20} width={20} />,
  [sidebarItemTypes.bonusProgramTerms]: <ClientsList height={20} width={20} />,
  [sidebarItemTypes.bonusProgramReport]: <TbReportMoney size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.adAccount]: <Accounts height={20} width={20} />,
  [sidebarItemTypes.providers]: <Providers height={20} width={20} />,
  [sidebarItemTypes.facebookReg]: <Fb height={20} width={20} />,
  [sidebarItemTypes.tikTokReg]: <TT height={20} width={20} />,
  [sidebarItemTypes.PLPostVerification]: <ResetPayline height={20} width={20} />,
  [sidebarItemTypes.PLVerification]: <Payline height={20} width={20} />,
  [sidebarItemTypes.PLPostVerification]: <Payline height={20} width={20} />,
  [sidebarItemTypes.verifyPayLine]: <Payline height={20} width={20} />,
  [sidebarItemTypes.verifySalesPayLine]: <Payline height={20} width={20} />,
  [sidebarItemTypes.googleMcc]: <Google height={20} width={20} />,
  [sidebarItemTypes.operationClosing]: <GrTransaction size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.manualTransactions]: <ManualManagement height={20} width={20} />,
  [sidebarItemTypes.manualPayment]: <ManualManagement height={20} width={20} />,
  [sidebarItemTypes.manualDebiting]: <RiRefund2Line size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.manualPenalty]: <MdMoneyOff size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.commissions]: <Commission height={20} width={20} />,
  [sidebarItemTypes.finDocs]: <FinDocIcon height={20} width={20} />,
  [sidebarItemTypes.paymentProblems]: <HiOutlineDocumentCurrencyDollar size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.competitionCertificate]: <HiOutlineDocumentCheck size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.usersItem]: <Client height={20} width={20} />,
  [sidebarItemTypes.users]: <ClientsList height={20} width={20} />,
  [sidebarItemTypes.projectsAccesses]: <TbLockAccess size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.reportsItem]: <Reporting height={20} width={20} />,
  [sidebarItemTypes.reports]: <HiOutlineDocumentCurrencyDollar size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.exchangeRate]: <MdCurrencyExchange size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.googleTax]: <TbTax size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.preModeration]: <MdOutlineFactCheck size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.advPartners]: <LiaHandsHelpingSolid size={20} color={"#C9C9C9"} />,
  [sidebarItemTypes.sentinel]: <Sentinel height={20} width={20} />,
  [sidebarItemTypes.demoCabinet]: <FaHammer  height={20} width={20} />,

})

